export default "__VITE_ASSET__CN5WUUf7__"